import React, { useEffect, useMemo, useState } from "react";
import StylesOrderManagemnt from "./StylesOrderManagemnt";
import { Tabs, Tab, TextField, InputAdornment, Box, Typography, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import CollapsibleTable from "../../components/CommonComponents/CollapsibleTable";
import { orderManagementData, orderManagementDataForActive, orderManagementDataForCancelled, orderManagementDataForReturned } from "../../components/CommonComponents/CollapsibleTable/dataFunctions";
import { useOrderManagemnt } from "../../hooks/common-hooks/useOrderManagemnt";
import NoDataFound from "../PrivateDashboard/NoDataFound";
import { getFormattedDate, toTwoDecimalPlaces } from "../../utils/commonFunctions";
import StatusTag from "../../components/CommonComponents/StatusTag";
import DoneIcon from "@mui/icons-material/Done";

import { ORDER_MANAGEMENT_LABELS } from "../../constants/lang";
import { fetchMarkShipped } from "../../store/reducers/createProfile";
import { useDispatch } from "react-redux";
import { ToastNotifyError, ToastNotifySuccess } from "../../components/CommonComponents/Toast/ToastNotify";
import rollbar from "../../rollbarConfig";
import wanderobelogo from "../../assets/images/wanderobe-logo-1.svg";

const {
    ORDER_NO,
    ORDER_PLACED_AT,
    SHIP_BY,
    TOTAL_ITEMS,
    PENDING_AMOUNT,
    RETURNED_ITEMS,
    KEPT_ITEMS,
    TOTAL_AMOUNT,
    CANCELLATION_DATE,
    PRODUCT_NAME,
    SIZE_COLOR,
    PRICE,
    QUANTITY,
    TABS,
    TABS_MAPPING,
    ACTION,
    STATUS
} = ORDER_MANAGEMENT_LABELS;

const HEADINGS = {
    New: [ORDER_NO, ORDER_PLACED_AT, SHIP_BY, TOTAL_ITEMS, PENDING_AMOUNT, STATUS, ACTION],
    Active: [ORDER_NO, ORDER_PLACED_AT, TOTAL_ITEMS, PENDING_AMOUNT, STATUS, ACTION],
    Returned: [ORDER_NO, ORDER_PLACED_AT, TOTAL_ITEMS, RETURNED_ITEMS, STATUS, ACTION],
    Completed: [ORDER_NO, ORDER_PLACED_AT, TOTAL_ITEMS, KEPT_ITEMS, TOTAL_AMOUNT, STATUS, ACTION],
    Cancelled: [ORDER_NO, ORDER_PLACED_AT, CANCELLATION_DATE, TOTAL_ITEMS, STATUS, ACTION],
};

const DETAILS_HEADING = [PRODUCT_NAME, SIZE_COLOR, PRICE, QUANTITY, TOTAL_AMOUNT];
const DETAILS_HEADING_STATUS = [PRODUCT_NAME, SIZE_COLOR, PRICE, QUANTITY, TOTAL_AMOUNT, STATUS];

const formatOrderItems = ({ product_image, product_name, size, color_code, color, price_per_unit, quantity, total_price }) => ({
    productName: (
        <Box sx={{
            display: "flex", alignItems: "center", gap: "12px", fontFamily: "Lexend",
            fontSize: "12px",
            textTransform: "capitalize"
        }}>
            <Box component="img" src={product_image?.[0] || wanderobelogo} sx={{ height: 40, width: 40, objectFit: "contain", border: "0.62px solid #CBCBCB" }} />
            <Box display="flex" gap="4px" flexDirection="column">
                <Typography className="text-truncate" fontSize={{ xs: "12px", md: "14px" }}>{product_name || "--"}</Typography>
                <Box sx={{ display: { xs: "flex", sm: "none" }, alignItems: "center", fontSize: "12px", color: "#656565" }}>{size || "--"} / <Box sx={{ height: "14px", width: "14px", background: color_code, marginLeft: "4px", marginRight: "3px", border: "0.1px solid lightgrey" }} />{color || "--"}</Box>
            </Box>
        </Box>
    ),
    size_color: (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            {size || "--"} /
            <Box sx={{ height: "14px", width: "14px", background: color_code, margin: "0 4px", border: "0.1px solid lightgrey" }} />
            {color || "--"}
        </Box>
    ),
    price: `$${price_per_unit || "0.00"}`,
    quantity: `x${quantity || 0}`,
    totalAmount: `$${total_price || "0.00"}`,
});
const formatOrderItemsStatus = ({ product_image, product_name, size, color_code, color, price_per_unit, quantity, total_price, keep_return }) => ({
    productName: (
        <Box sx={{
            display: "flex", alignItems: "center", gap: "12px", fontFamily: "Lexend",
            fontSize: "12px",
            textTransform: "capitalize"
        }}>
            <Box component="img" src={product_image?.[0] || wanderobelogo} sx={{ height: 40, width: 40, objectFit: "contain", border: "0.62px solid #CBCBCB" }} />
            <Box display="flex" gap="4px" flexDirection="column">
                <Typography className="text-truncate" fontSize={{ xs: "12px", md: "14px" }}>{product_name || "--"}</Typography>
                <Box sx={{ display: { xs: "flex", sm: "none" }, alignItems: "center", fontSize: "12px", color: "#656565" }}>{size || "--"} / <Box sx={{ height: "14px", width: "14px", background: color_code, marginLeft: "4px", marginRight: "3px", border: "0.1px solid lightgrey" }} />{color || "--"}</Box>
            </Box>
        </Box>
    ),
    size_color: (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            {size || "--"} /
            <Box sx={{ height: "14px", width: "14px", background: color_code, margin: "0 4px", border: "0.1px solid lightgrey" }} />
            {color || "--"}
        </Box>
    ),
    price: `$${price_per_unit || "0.00"}`,
    quantity: `x${quantity || 0}`,
    totalAmount: `$${total_price || "0.00"}`,
    totalStatus: keep_return !== "keep" ? <StatusTag status="Returned" /> : "" 
});
const formatOrderItemsStatus2 = ({ product_image, product_name, size, color_code, color, price_per_unit, quantity, total_price, keep_return }) => ({
    productName: (
        <Box sx={{
            display: "flex", alignItems: "center", gap: "12px", fontFamily: "Lexend",
            fontSize: "12px",
            textTransform: "capitalize"
        }}>
            <Box component="img" src={product_image?.[0] || wanderobelogo} sx={{ height: 40, width: 40, objectFit: "contain", border: "0.62px solid #CBCBCB" }} />
            <Box display="flex" gap="4px" flexDirection="column">
                <Typography className="text-truncate" fontSize={{ xs: "12px", md: "14px" }}>{product_name || "--"}</Typography>
                <Box sx={{ display: { xs: "flex", sm: "none" }, alignItems: "center", fontSize: "12px", color: "#656565" }}>{size || "--"} / <Box sx={{ height: "14px", width: "14px", background: color_code, marginLeft: "4px", marginRight: "3px", border: "0.1px solid lightgrey" }} />{color || "--"}</Box>
            </Box>
        </Box>
    ),
    size_color: (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            {size || "--"} /
            <Box sx={{ height: "14px", width: "14px", background: color_code, margin: "0 4px", border: "0.1px solid lightgrey" }} />
            {color || "--"}
        </Box>
    ),
    price: `$${price_per_unit || "0.00"}`,
    quantity: `x${quantity || 0}`,
    totalAmount: `$${total_price || "0.00"}`,
    totalStatus: keep_return === "keep" ? <StatusTag status="Kept" /> : "" 
});

export default function OrderManagement() {
    const { products, loading, setCategory, setSearch, pageSize, setPageSize, count, setCount, pageDetails, searchProducts } = useOrderManagemnt();
    const [orderType, setOrderType] = useState(TABS[0]);

    const handleChange = (event, newValue) => {
        if (orderType !== newValue) {
            setOrderType(newValue);
            setCategory(TABS_MAPPING[newValue]);
        }
    };

    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const dispatch = useDispatch();

    const markStatus = (seller_status, status, id) => {
        if (seller_status.toLowerCase() === "ship_to_wanderobe"){
            return <StatusTag status={seller_status} />
        } 
        if (status.toLowerCase() === "pending from logistics"){
            return (
                <Box>
                  <Button variant='contained' color='primary' className='action-btn'onClick={() => MarkToShip(id)}>
                    <DoneIcon sx={{ fontSize: "16px", color: "white" }} />
                    <Typography className='action-text'>Ready to ship</Typography>
                  </Button>
                </Box>
            )
        } else {
            return <StatusTag status={status} />
        }
    }
    
    const formatOrderData = (order, orderType) => {
        const {
            order_no,
            creation_date,
            arrival_date,
            order_items_count,
            price_total,
            order_items,
            order_cancellation_date,
            kept_items,
            seller_status,
            action,
            id
        } = order;
    
        const orderItems = order_items?.map(formatOrderItems) || [];
        const orderItemsStatus = order_items?.map(formatOrderItemsStatus) || [];
        const orderItemsStatus2 = order_items?.map(formatOrderItemsStatus2) || [];
        const orderNo = `#${order_no}`;
        const creationDate = creation_date ? getFormattedDate(creation_date, "d MMM yyyy, h:mm a") : "--";
        const totalItems = order_items_count || "--";
        const totalPrice = `$${toTwoDecimalPlaces(price_total) || "--"}`;
        const newStatusTag = <StatusTag status={seller_status} />;
    
        switch (orderType) {
            case "New":
                return orderManagementData(orderNo, creationDate, arrival_date ? getFormattedDate(arrival_date, "d MMM yyyy") : "--", totalItems, totalPrice, markStatus(seller_status, action, id), orderItems);
            case "Active":
                return orderManagementDataForActive(orderNo, creationDate, totalItems, totalPrice, newStatusTag, orderItems);
            case "Returned":
                return orderManagementDataForReturned(orderNo, creationDate, totalItems, order_items_count - kept_items || "--", newStatusTag, orderItemsStatus, totalPrice);
            case "Completed":
                return orderManagementData(orderNo, creationDate, totalItems, `${kept_items}`, totalPrice, newStatusTag, orderItemsStatus2);
            case "Cancelled":
                return orderManagementDataForCancelled(orderNo, creationDate, order_cancellation_date ? getFormattedDate(order_cancellation_date, "d MMM yyyy, h:mm a") : "--", totalItems, newStatusTag, orderItems, totalPrice);
            default:
                return [];
        }
    };
// eslint-disable-next-line react-hooks/exhaustive-deps
    const invoiceRows = useMemo(() => products?.map((order) => formatOrderData(order, orderType)), [orderType, products]);

    const MarkToShip = async(id) => {
        try{
          const res = await dispatch(fetchMarkShipped(id));
          const { status, message } = res?.payload || {};
          if(status){
            ToastNotifySuccess("Item is marked as shipped");
            searchProducts();
          } else {
            ToastNotifyError(message);
          }
        } catch(err){
          console.log("err :", err)
          rollbar.error("Error message", err);
        }
      }

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };

    }, [searchTerm]);

    useEffect(() => {


        setSearch(debouncedSearchTerm);

    }, [debouncedSearchTerm, setSearch]);
    return (
        <StylesOrderManagemnt>
            <div className="tabs-container">
                <Tabs
                    value={orderType}
                    onChange={handleChange}
                    className="tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    textColor="secondary"
                    indicatorColor="secondary"
                >
                    {TABS.map((tab, index) => (
                        <Tab className="tab-option" key={index} value={tab} label={tab} />
                    ))}
                </Tabs>
            </div>
            <TextField
                disabled={products?.length === 0 && searchTerm?.length === 0}
                placeholder="Search by order id"
                className="search-box"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon className="searchIcon" />
                        </InputAdornment>
                    ),
                }}
            />

            <CollapsibleTable
                loading={loading}
                noDataComponent={
                    <NoDataFound
                        icon={<ShoppingBagOutlinedIcon className="icon-no-data" />}
                        heading="Nothing Here Yet!"
                        subHeading="Your inventory list will appear once you add products."
                    />
                }
                showPagination
                sxHeight="calc(100vh - 230px)"
                sxMobileHeight={pageDetails?.total_pages <= 3 ? "calc(100vh - 270px)" : "calc(100vh - 306px)"}
                pageNo={count}
                pageSize={pageDetails?.total_count >= 10 ? pageSize : pageDetails?.total_count}
                setPageNo={setCount}
                setPageSize={setPageSize}
                headings={HEADINGS[orderType] || []}
                rows={invoiceRows}
                isDownIconVisible
                totalCount={pageDetails?.total_count}
                totalPages={pageDetails?.total_pages}
                detailsHeading={orderType === "Returned" || orderType === "Completed" ? DETAILS_HEADING_STATUS : DETAILS_HEADING}
            />

        </StylesOrderManagemnt>
    );
}
